import React, { ReactNode } from 'react';
import { classNames } from '../../utils/style';
import { fontHeading1, fontBody } from '../../styles/typographyNew';
import { featureContainer } from '@payfit/growth-platform-brand-system-v2/styles/themes';

export interface HeroMinimalProps {
  title: string;
  subtitle: string;
  ctaButtons?: ReactNode[];
  className?: string;
  alignment?: 'left' | 'center';
}

export const HeroMinimal: React.FC<HeroMinimalProps> = ({
  title,
  subtitle,
  ctaButtons,
  className,
  alignment = 'left',
}) => {
  return (
    <section
      className={classNames(
        'HeroMinimal',
        'flex flex-col',
        alignment === 'left'
          ? 'justify-start xl:flex-row xl:items-end xl:justify-between'
          : 'justify-center xl:items-center xl:justify-center',
        'mb-48 gap-6',
        featureContainer,
        className,
      )}
    >
      <div
        className={classNames(
          'flex flex-col',
          alignment === 'left'
            ? 'items-start justify-start xl:max-w-[819px]'
            : 'items-center justify-center text-center xl:max-w-[1034px]',
          'gap-8',
        )}
      >
        <h1
          className={classNames(
            fontHeading1,
            'text-default-title',
            'break-words',
          )}
        >
          {title}
        </h1>
        <p className={classNames(fontBody, 'text-default-content')}>
          {subtitle}
        </p>
      </div>

      {ctaButtons && ctaButtons.length > 0 && (
        <div
          className={classNames(
            'flex flex-col sm:flex-row',
            'gap-12',
            'w-full md:w-auto',
            alignment === 'center' && 'justify-center',
            alignment === 'left' && 'xl:flex-col',
          )}
        >
          {ctaButtons}
        </div>
      )}
    </section>
  );
};
